__turbopack_context__.v({
  "content": "_7G08oa_content",
  "contentBorder": "_7G08oa_contentBorder",
  "description": "_7G08oa_description",
  "header": "_7G08oa_header",
  "heading": "_7G08oa_heading",
  "headingContainer": "_7G08oa_headingContainer",
  "languageFilterContainer": "_7G08oa_languageFilterContainer",
  "linkItem": "_7G08oa_linkItem",
  "linkList": "_7G08oa_linkList",
});
